// 不同断点下的水印
export const endPointsWatermarks = [
  {
    // 240
    range: [0, 600],
    key: 'cHVibGljL3dhdGVybWFya3MvMjQwLnBuZw==',
  },
  {
    // 400
    range: [601, 1000],
    key: 'cHVibGljL3dhdGVybWFya3MvNDAwLnBuZw==',
  },
  {
    // 600
    range: [1001, 1500],
    key: 'cHVibGljL3dhdGVybWFya3MvNjAwLnBuZw==',
  },
  {
    // 1000
    range: [1501, 2500],
    key: 'cHVibGljL3dhdGVybWFya3MvMTAwMC5wbmc=',
  },
  {
    // 1600
    range: [2501, 4000],
    key: 'cHVibGljL3dhdGVybWFya3MvMTYwMC5wbmc=',
  },
  {
    // 2600
    range: [4001, Infinity],
    key: 'cHVibGljL3dhdGVybWFya3MvMjYwMC5wbmc=',
  },
];
